/**
 *
 * 12345 => $12,345.00
 *
 * @param {String} sign
 * @param {Number} decimals Decimal places
 */

function currency (value, currency = '€', decimals = 2) {
  value = parseFloat(value)
  if (! isFinite(value) || (! value && value !== 0)) {
    return ''
  }

  const stringified = Math.abs(value).toFixed(decimals)
  const _int = decimals
    ? stringified.slice(0, -1 - decimals)
    : stringified
  const _float = decimals
    ? ',' + stringified.slice(-decimals)
    : ''
  const sign = value < 0 ? '-' : ''

  return sign + currency +' '+ _int + _float
}

export default currency


// WEBPACK FOOTER //
// ./resources/assets/front/js/shared/currency.js